import { ICellRendererParams } from 'ag-grid-enterprise';
import React from 'react';
import LinearWithLabel from '../@extended/Progress/LinearWithLabel';
import { useTheme } from '@mui/material/styles';

interface ProgressBarParams extends ICellRendererParams {
  amtPaidClr: number;
  amtPaidPnd: number;
  factorRate: number;
  completionValue: number;
  amount: number;
  useCompactViewStyle?: boolean;
}
export const ProgressBarCell = ({ amtPaidClr, amtPaidPnd, factorRate, completionValue, amount, useCompactViewStyle=false }: ProgressBarParams) => {
  const theme = useTheme();
  const bufferValue = ((Number(amtPaidClr) + Number(amtPaidPnd)) / (Number(amount) * Number(factorRate))) * 100;

  const getBarColor = (v: number) => {
    if (v < 25) return theme.palette.salmon.main;
    if (v < 50) return theme.palette.sandybrown.main;
    if (v < 75) return theme.palette.dodgerblue.main;
    return theme.palette.springgreen.main;
  };
  const barColor = getBarColor(completionValue);

  return (
    <LinearWithLabel
      variant="buffer"
      value={completionValue}
      valueBuffer={bufferValue}
      useCompactViewStyle={useCompactViewStyle}
      sx={{
        '& .MuiLinearProgress-bar1Buffer': {
          backgroundColor: barColor
        }
      }}
    />
  );
};
